import { Component, OnInit } from '@angular/core';
import { CfetBaseComponent } from '../../../cfet-core';
import { environment } from './../../../../environments/environment';
import { Title } from '@angular/platform-browser';
import {DatePipe} from '@angular/common';
 import 'add-to-calendar-button';
@Component({
    selector: 'app-complete-profile-confirmation-utf',
    templateUrl: './complete-profile-confirmation-utf.component.html',
    styleUrls: ['./complete-profile-confirmation-utf.component.scss'],
    standalone: false
})
export class CompleteProfileConfirmationUtfComponent extends CfetBaseComponent implements OnInit {
  returnUrl = '';
  isReturnUrl: boolean = false;
  attId: any;
  verificationStatus: any;
  statusCheck = false;
  getPersonalInfo: any;
  emailAddress = '';
  firstName = '';
  url: any;
  orgInformation: any;
  utfToken: any;
  linkCuser: any;
  date = new Date()
  calendarName = "Verify your Firstnet eligibility" ;
  calendarLocation = "https://FirstNet.com/verify";
  calendarOptions = "['Apple','Google','iCal','Microsoft365','Outlook.com','Yahoo']";
  calendarStartDate = this.datePipe.transform(this.date.setDate( this.date.getDate() + 7 ), "yyyy-MM-dd");
  calendarEndDate = this.calendarStartDate;
  calendarStartTime = this.datePipe.transform(this.date, "HH:mm");
  calendarEndTime = this.timeAddMinutes(this.calendarStartTime, 30);
  calendarTimeZone = "currentBrowser" ;
  calendarButtonText = "Set a calendar reminder for 7 days from now";
  calendardescription = "Please visit the link to validate your eligibility: " + this.calendarLocation;
  skipDocUpload: boolean | undefined;
  hasDomainValue: boolean;
  constructor(private title: Title,
    private datePipe: DatePipe
  ) { super(); }

  ngOnInit () {
    this.title.setTitle(this.cfetTitles.confirmation.utfHtmlTitle);
    const skipDocUploadValue = sessionStorage.getItem('skipDocUpload');
    if (skipDocUploadValue === 'true') {
      this.skipDocUpload = true;
    } else if (skipDocUploadValue === 'false') {
      this.skipDocUpload = false;
    } else {
      this.skipDocUpload = undefined;
    }
    const hasDomainValue = sessionStorage.getItem('hasDomainValue'); // Read the flag
    if (hasDomainValue === 'true') {
       this.hasDomainValue = true;
    }
    if ((sessionStorage.getItem('ngStorage-savedData') && Object.keys(sessionStorage.getItem('ngStorage-savedData')).length !== 0)) {
      this.getPersonalInfo = JSON.parse(sessionStorage.getItem('ngStorage-savedData'));
      this.emailAddress = (this.getPersonalInfo && this.getPersonalInfo.emailaddress) ? this.getPersonalInfo.emailaddress : '';
      this.firstName = (this.getPersonalInfo && this.getPersonalInfo.firstname) ? this.getPersonalInfo.firstname : '';
      this.attId = (this.getPersonalInfo && this.getPersonalInfo.attID) ? this.getPersonalInfo.attID : '';
    }
    if (sessionStorage.getItem('orgInfo') && Object.keys(sessionStorage.getItem('orgInfo')).length !== 0) {
      this.orgInformation = JSON.parse(sessionStorage.getItem('orgInfo'));
      this.statusCheck = (this.orgInformation && (this.orgInformation['isSpaOrg'] === undefined || this.orgInformation['isSpaOrg'] === ''
        || this.orgInformation['isSpaOrg'] === false)) ? true : false;
    }
    this.getSessionData();
  }

  getSessionData () {
    this.verificationStatus = sessionStorage.getItem('verificationStatus');
    this.statusCheck = (this.verificationStatus === 'NotRequired' || this.verificationStatus === 'success') ? true : false;
    if (sessionStorage.getItem('returnUrl') && Object.keys(sessionStorage.getItem('returnUrl').length !== 0)) {
      this.returnUrl = JSON.parse(sessionStorage.getItem('returnUrl'))
    }
    this.isReturnUrl = this.returnUrl ? true : false;
    if (sessionStorage.getItem('utfToken') && sessionStorage.getItem('utfToken') !== '') {
      this.utfToken = sessionStorage.getItem('utfToken');
    }
    if (sessionStorage.getItem('linked_c_user') || sessionStorage.getItem('linked_c_user') == '') {
      this.linkCuser = sessionStorage.getItem('linked_c_user');
    }
  }
  timeAddMinutes(time, min) {
    let t = time.split(":"),
      h = Number(t[0]),
      m = Number(t[1]);
    m += min % 60;
    h += Math.floor(min / 60);       // increment hours
    if (m >= 60) { h++; m -= 60 }   // if resulting minues > 60 then increment hours and balance as minutes

    return (h + "").padStart(2, "0") + ":"  //create string padded with zeros for HH and MM
      + (m + "").padStart(2, "0");

  }  

  continue (event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      if (this.linkCuser == '') {
        const url = environment.premierDashboard;
        window.location.href = url;
      } else if (sessionStorage.getItem('returnUrl') && Object.keys(sessionStorage.getItem('returnUrl').length !== 0)) {
        this.url = JSON.parse(sessionStorage.getItem('returnUrl'));
        if (this.url && this.url.indexOf('?') === -1) {
          this.redirectUrl(encodeURIComponent(this.url + '?fnStatus=eligible'));
        } else {
          this.redirectUrl(encodeURIComponent(this.url + '&fnStatus=eligible'));
        }
      } else {
        // Redirect to plp page
        const url = environment.plp_page;
        this.redirectUrl(encodeURIComponent(url + '&fnStatus=eligible'));
      }
    }
  }

  shopNow(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      const url = environment.premierDashboard;
      this.redirectUrl(encodeURIComponent(url));
    }
  }
  shopNowFirstnet(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      const url = environment.premierDashboard;

      if (url && url.indexOf('?') === -1) {
        this.redirectUrl(encodeURIComponent(url + '?fnStatus=eligible'));
      } else {
        this.redirectUrl(encodeURIComponent(url + '&fnStatus=eligible'));
      }
    }
  }

  changePlan(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      const url = environment.changePlan;
      this.redirectUrl(encodeURIComponent(url));
    }
  }

  redirectUrl (url) {
    window.location.href = environment.fn_SessionUrl + this.utfToken + '&returnURL=' + url;
  }

}
